import React, { useEffect, useState } from "react";
import CustomContainer from "../components/CustomContainer";
import {
  Grid,
  Typography,
  Box,
  IconButton,
  List,
  useMediaQuery,
  useTheme,
  Tooltip,
  ButtonGroup,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import GridViewIcon from "@mui/icons-material/GridView";
import ViewListIcon from "@mui/icons-material/ViewList";
import ProjectCard from "../components/ProjectCard";
import ProjectListItem from "../components/ProjectListItem";
import { Project, ViewModes } from "../@types/types";
import { projects } from "../config";

const Projects: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [viewMode, setViewMode] = useState<ViewModes>(ViewModes.GRID);
  const [filter, setFilter] = useState<string>("all");

  const filteredProjects: Project[] = projects.filter((project) => {
    if (filter === "all") {
      return true;
    }
    return project.type === filter;
  });

  const toggleViewMode = () => {
    setViewMode((prevMode) =>
      prevMode === ViewModes.GRID ? ViewModes.LIST : ViewModes.GRID
    );
  };

  useEffect(() => {
    if (isMobile) {
      setViewMode(ViewModes.GRID);
    }
  }, [isMobile]);

  return (
    <CustomContainer id="#projects">
      <Box sx={{ mb: 4 }}>
        <Typography variant="h3" component="h2" gutterBottom>
          {t("Projects")}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
        }}
      >
        <ButtonGroup
          variant="text"
          color="primary"
          aria-label="text primary button group"
        >
          <Button
            onClick={() => setFilter("all")}
            variant={filter === "all" ? "contained" : "outlined"}
          >
            {t("All")}
          </Button>
          <Button
            onClick={() => setFilter("full-stack")}
            variant={filter === "full-stack" ? "contained" : "outlined"}
          >
            {t("Full Stack")}
          </Button>
          <Button
            onClick={() => setFilter("frontend")}
            variant={filter === "frontend" ? "contained" : "outlined"}
          >
            {t("Frontend")}
          </Button>
        </ButtonGroup>

        {!isMobile && (
          <Box>
            <Tooltip title={t("View as Grid")}>
              <IconButton
                size="small"
                onClick={toggleViewMode}
                color={viewMode === ViewModes.GRID ? "primary" : "default"}
              >
                <GridViewIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title={t("View as List")}>
              <IconButton
                size="small"
                onClick={toggleViewMode}
                color={viewMode === ViewModes.LIST ? "primary" : "default"}
              >
                <ViewListIcon />
              </IconButton>
            </Tooltip>
          </Box>
        )}
      </Box>

      {viewMode === ViewModes.GRID ? (
        <Grid container spacing={4}>
          {filteredProjects.map((project) => (
            <Grid item key={project.id} xs={12} sm={6} md={6}>
              <ProjectCard project={project} />
            </Grid>
          ))}
        </Grid>
      ) : (
        <List>
          {filteredProjects.map((project) => (
            <ProjectListItem key={project.id} project={project} />
          ))}
        </List>
      )}
    </CustomContainer>
  );
};

export default Projects;
